import React, { useState } from 'react';
import { useAppContext } from '../../../Context/AppContext';
import { getFileIconCss } from '../../../Utility';
import SubSectionHeader from '../../Shared/SubSectionHeader';
import classes from './Attachments.module.css';
import { ActivityString } from '../../../Constants';
import FileHandler, { FileViewer } from '../../../Components/Shared/FileHandler/FileHandler';


const Attachments = () => {
  const { transporterInfo, isEditable } = useAppContext();

  const [viewFileData, setViewFileData] = useState(null);
  const [viewFileUrl, setViewFileUrl] = useState('');
  const [viewOpen, setViewOpen] = useState(false);
  const handleViewFile = (url, data) => {
    setViewFileUrl(url);
    setViewFileData(data);
    setViewOpen(true);
  };

  return (
    <div className={classes.container + ' sub-section-container'}>
      {Object.keys(transporterInfo).length === 0 ? null : (
        <>
          <SubSectionHeader title="Attachments" />
          {isEditable ? (
            <EditMode
              attachments={transporterInfo.attachments}
              transporterId={transporterInfo.transporter_id}
              onViewFile={handleViewFile}
            />
          ) : (
            <ReadOnly
              attachments={transporterInfo.attachments}
              onViewFile={handleViewFile}
            />
          )}
          {viewOpen && (
            <FileViewer
              viewFile={viewOpen}
              setViewFile={setViewOpen}
              viewFilePath={viewFileUrl}
              fileViewHeader={viewFileData?.title}
              fileName={viewFileData?.fileName}
              numPages={viewFileData?.numPages || null}
              loading={false}
              onDocumentLoadSuccess={() => {}}
            />
          )}
        </>
      )}
    </div>
  );
};

const EditMode = ({ attachments = [], transporterId, onViewFile }) => (
  <div className={classes['cards-container']}>
    {attachments.map(a => (
      <Card title={a.name} fileName={a['file_name'] || 'No file'} key={a.name}>
        <FileHandler
          onUpload={(fileid, fileName) => {
            a['blob_url'] = fileid;
            a['file_name'] = fileName;
            a['uploaded_on'] = new Date().toISOString();
          }}
          transporterId={transporterId}
          lastUpdated={a.uploaded_on}
          fileDescription={a.name}
          screen={ActivityString.GeneralInfo}
          modulename={'Attachments'}
          onViewFile={onViewFile}
          title={a.name}
          fileName={a.file_name}
          fileId={a.blob_url}
        />
      </Card>
    ))}
  </div>
);

const ReadOnly = ({ attachments = [], onViewFile }) => (
  <div className={classes['cards-container']}>
    {attachments.map(a => (
      <Card title={a.name} fileName={a['file_name'] || 'Please upload a file'} key={a.name}>
        <FileHandler
          fileId={a.blob_url}
          lastUpdated={a.uploaded_on}
          fileName={a['file_name']}
          className={classes['margin-top-5px']}
          fileDescription={a.name}
          screen={ActivityString.GeneralInfo}
          modulename={'Attachments'}
          title={a.name}
          onViewFile={onViewFile}
        />
      </Card>
    ))}
  </div>
);

const Card = ({ title, fileName, children }) => {
  const fileType = getFileIconCss(fileName);

  return (
    <div className={classes.card} >
      <div className={classes.header}>
        {title.replace(/([a-z])([A-Z])/g, '$1 $2')}
      </div>
      <div className={classes['uploader']} title={fileName}>
        <img alt='img' src={fileType.icon} className={classes['attachment-filetype-icon']}></img>
      </div>
      {children}
    </div>
  );
}


export default Attachments;
